import { LOGO_URL } from "../lib/constants";

export default function DataDeletion() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="data-deletion-page">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-6 py-5 flex items-center gap-3">
          <img src={LOGO_URL} alt="Grian Solar Power" className="h-9 w-auto" data-testid="data-deletion-logo" />
          <span className="font-semibold text-slate-900">Grian Solar Power</span>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-slate-900 mb-1">Data Deletion Instructions</h1>
        <p className="text-xs text-slate-400 mb-10">Last updated: June 2026</p>

        <div className="text-sm leading-relaxed text-slate-600 space-y-4">
          <p>
            Grian Solar Power (ABN 91 635 362 560) respects your right to control your personal
            information. If you have submitted an enquiry to us — including via our Facebook or
            Instagram Lead Ad forms — and would like us to delete the personal information we hold
            about you, you can request deletion at any time.
          </p>

          <h2 className="text-lg font-semibold text-slate-900 pt-4">How to request deletion</h2>
          <p>
            Send an email to{" "}
            <a href="mailto:info@griansolarpower.com.au" className="text-emerald-600 underline">
              info@griansolarpower.com.au
            </a>{" "}
            (or call us on{" "}
            <a href="tel:0485976518" className="text-emerald-600 underline">0485 976 518</a>) with the
            subject line <strong>"Data Deletion Request"</strong> and include:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Your full name</li>
            <li>The phone number and/or email address you used when contacting us</li>
          </ul>
          <p>
            We will verify your identity and permanently delete the personal information we hold about
            you within <strong>30 days</strong>, except where we are required to retain certain records
            by law (for example, for tax or rebate-compliance purposes).
          </p>

          <h2 className="text-lg font-semibold text-slate-900 pt-4">Facebook / Instagram lead data</h2>
          <p>
            If you submitted your details through one of our Facebook or Instagram Lead Ad forms, we
            receive only the information you chose to submit on that form. Sending us a deletion request
            as described above will remove that information from our CRM system.
          </p>

          <p className="pt-4">
            For more information about how we handle your data, please read our{" "}
            <a href="/privacy" className="text-emerald-600 underline" data-testid="data-deletion-privacy-link">
              Privacy Policy
            </a>.
          </p>
        </div>
      </main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="max-w-3xl mx-auto px-6 py-6 text-xs text-slate-400">
          © {new Date().getFullYear()} Grian Solar Power. ABN 91 635 362 560.
        </div>
      </footer>
    </div>
  );
}
